export interface IPessimization {
  background: EPessimizationBackground;
  text: string;
}

export enum EPessimizationBackground {
  Gray = 'gray',
  Red = 'red',
}
